import { QueryClient } from '@tanstack/react-query'

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 1000 * 30,         // 30s — Firestore listeners handle fresh data
      gcTime: 1000 * 60 * 5,        // 5min cache after unmount
      retry: 1,
      refetchOnWindowFocus: false,   // Firestore realtime covers this
    },
    mutations: {
      retry: 0,
    },
  },
})
